import React, { useState } from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ano,
    mes,
    dia,
    arrayDataToData,
    dataAtualSemHora,
    somaDiasData,
} from '../../../business-components/Date/Date'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    IconButtonEditar,
    IconButtonClearEntradaDados,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

//import {
//    pesquisaDescricaoList,
//} from '../../../../business-rules/List/ListService'

import {
    selecionaVersao,
    incluiVersao,
} from './VersaoService'



const VersaoForm = ({ variaveisGlobais, values, handleChange }) => {

    const [processando, setProcessando] = useState(false)

    const incluirVersao = async () => {

        setProcessando(true)

        await incluiVersao(variaveisGlobais, values)

        setProcessando(false)
    }



    return (
        <FieldArray name="jsonComparacaoEstudos.estudos">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm>
                        <GridContainer
                            className='mb-4 font-bold'
                        >
                            <GridItem1>
                                {LABEL.versao}
                            </GridItem1>

                            <GridItem2>
                                {LABEL.dataEstudo}
                            </GridItem2>

                            <GridItem3>
                                {LABEL.cenarioPrincipalAbreviado}
                            </GridItem3>

                            <GridItem4>
                                {LABEL.naoExibirComparacaoEstudos}
                            </GridItem4>
                        </GridContainer>

                        <GridContainer>
                            {values.jsonComparacaoEstudos.estudos?.map((item, ind) => {

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem1>
                                                {values.jsonComparacaoEstudos.estudos[ind].id}
                                            </GridItem1>

                                            <GridItem2>
                                                {values.jsonComparacaoEstudos.estudos[ind].descricao}
                                            </GridItem2>

                                            <GridItem3>
                                                {/*pesquisaDescricaoList(values.jsonComparacaoEstudos.estudos[ind].cenarios,
                                                    values.jsonComparacaoEstudos.estudos[ind].cenarioPrincipal)*/}
                                                {values.jsonComparacaoEstudos.estudos[ind].descricaoCenarioPrincipal}
                                            </GridItem3>

                                            <GridItem4
                                                className='mt--4'
                                            >
                                                <CheckboxPadrao
                                                    name={`jsonComparacaoEstudos.estudos[${ind}].naoExibirComparacaoEstudos`}
                                                    label={''}
                                                    checked={item.naoExibirComparacaoEstudos}
                                                    onChange={handleChange}
                                                    disabled={ind === values.jsonComparacaoEstudos.estudos.length - 1}
                                                />
                                            </GridItem4>

                                            <GridItem1
                                                className='mt--2'
                                            >
                                                <IconButtonEditar
                                                    onClick={() =>
                                                        selecionaVersao(variaveisGlobais, values, item.id)
                                                    }
                                                />
                                            </GridItem1>

                                            <GridItem1>
                                                {false && values.jsonComparacaoEstudos.estudos[ind].id !== 1 && (
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            null
                                                        }
                                                    />
                                                )}
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem12>
                                )
                            })}
                        </GridContainer>
                    </DivForm>

                    {values.ultimaVersao === values.versao &&
                    somaDiasData(dataAtualSemHora(), HARDCODE.diasCriarNovaVersao) > arrayDataToData([ano(values.dataSimulacaoEstudo), mes(values.dataSimulacaoEstudo), dia(values.dataSimulacaoEstudo)]) && (
                        <GridContainer>
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirVersao} 
                                onClick={() => {
                                    incluirVersao()
                                }}
                                disabled={processando}
                            />
                        </GridContainer>
                    )}
                </DivForm>
            )}
        </FieldArray>
    )
}

export default VersaoForm